import React, { useState } from "react";

import { ViewStyle, View } from "react-native";
import NavBarButton from "../NavBar/NavBarButton";
import { IcFilter, IcLightBulb } from "../../utils/Icons";
import { TipIds, TipIdsByCycle } from "../../models/Tips";
import User from "../../data/user/User";
import Modal from "../../../specific/components/Modal/Modal";
import DocumentsViewer from "../Documents/DocumentsViewer";
import PDFViewer from "../../../specific/components/PDF/PDFViewer";
import { localizedString } from "../Activities/ActivitySheet";
import { getLanguage } from "../../utils/Localization/Localization";
import AppTheme from "../../utils/Theme";
import UserLevelSelection from "../Filters/UserLevelSelection";

interface LevelsButtonProps {
    style?: ViewStyle;
}

const LevelsButton = (props: LevelsButtonProps) => {
    const { style } = props;
    const user: User = User.getInstance();
    const appTheme: AppTheme = new AppTheme();

    const [showLevelSelection, setShowLevelSelection] = useState<boolean>(false);

    return <View>
        <NavBarButton icon={IcFilter} color={appTheme.darkBlue} style={style} action={() => setShowLevelSelection(true)} />
        <UserLevelSelection
            visible={showLevelSelection}
            style={{ width: "100%", height: "100%", justifyContent: "flex-end" }}
            backgroundColor={appTheme.schoolColor}
            toggleFilters={() => setShowLevelSelection(false)} />
    </View>
}

export default LevelsButton;